import EditControlls from "../../../components/admin/edit-controlls";
import AdminMenu from "../../../components/admin/menu";
import AdminPageContainer from "../../../components/admin/page-container";

type Props = {}

const AdminMainPage: React.FC<Props> = () => {

    return <AdminPageContainer>
        <AdminMenu />
        <div>
            <h2>Ustawienia aplikacji</h2>
            <EditControlls />
        </div>
    </AdminPageContainer>
}

export default AdminMainPage;
